<template>
  <v-form
    :disabled="form.processing"
    @submit.prevent="submit"
  >
    <v-card>
      <v-card-text
        v-if="$page.props.user.is_demo"
        class="pb-0"
      >
        <v-alert
          type="info"
          class="mb-0"
        >
          {{ $t('This feature is disabled for demo accounts') }}
        </v-alert>
      </v-card-text>
      <v-card-title>{{ $t('Create a new team') }}</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="form.name"
          autofocus
          solo
          :disabled="$page.props.user.is_demo"
          :loading="form.processing"
          :error-messages="form.errors.name"
          persistent-placeholder
          :placeholder="$t('Enter team name')"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          type="submit"
          color="primary"
          :loading="form.processing"
          :disabled="form.processing || $page.props.user.is_demo"
        >
          {{ $t('Create') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      form: this.$inertia.form({
        name: ''
      })
    }
  },
  methods: {
    submit() {
      const url = this.route('team.store');
      this.form.post(url, {
          onSuccess: () => {
            this.form.name = '';
          }
      });
    }
  }
}
</script>